import React from 'react';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import './Pagination.css';

export default function Pagination({ currentPage, totalPages, onPageChange }) {
  const canGoPrevious = currentPage > 1;
  const canGoNext = currentPage < totalPages;

  return (
    <div className="pagination">
      <button
        onClick={() => onPageChange(1)}
        disabled={!canGoPrevious}
        className="pagination__button"
        aria-label="Primeira página"
      >
        <ChevronsLeft className="w-5 h-5" />
      </button>

      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={!canGoPrevious}
        className="pagination__button"
        aria-label="Página anterior"
      >
        <ChevronLeft className="w-5 h-5" />
      </button>

      <span className="pagination__info">
        Página {currentPage} de {totalPages}
      </span>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={!canGoNext}
        className="pagination__button"
        aria-label="Próxima página"
      >
        <ChevronRight className="w-5 h-5" />
      </button>

      <button
        onClick={() => onPageChange(totalPages)}
        disabled={!canGoNext}
        className="pagination__button"
        aria-label="Última página"
      >
        <ChevronsRight className="w-5 h-5" />
      </button>
    </div>
  );
}
